module.exports = __webpack_public_path__ + "static/media/KOL5-NEW.cd0842b1.apng";